import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

/**
 * Текущий Token.
 */

const initialState: string = '';

export const userTokenSlice = createSlice({
  name: 'userToken',
  initialState,
  reducers: {
    userToken: (state, action: PayloadAction<string>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { userToken } = userTokenSlice.actions;

export default userTokenSlice.reducer;
